import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import LockRoundedIcon from '@mui/icons-material/LockRounded';
import { usePermissions } from '../hooks/usePermissions';

// Route-level permission guard. Renders an in-place "access denied" message
// rather than redirecting, since the only way to land here despite a hidden
// sidebar is a direct URL - the user should understand why, not just bounce.
export default function PermissionRoute({ module, action }) {
  const { can } = usePermissions();

  if (!can(module, action)) {
    return (
      <Box sx={{ textAlign: 'center', py: 10 }}>
        <LockRoundedIcon sx={{ fontSize: 40, color: 'text.secondary', mb: 1.5 }} />
        <Typography variant="h6">You don't have access to this page</Typography>
        <Typography variant="body2" color="text.secondary" mt={0.5}>
          Ask a company admin or owner if you need this permission.
        </Typography>
      </Box>
    );
  }

  return <Outlet />;
}
